import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon, Trigger } from '@radix-ui/react-select';
import { cn } from 'cn';

interface Props extends React.ComponentPropsWithoutRef<typeof Trigger> {
  variant?: 'default' | 'ghost';
  endAdornment?: React.ReactNode;
  ref?: React.Ref<React.ElementRef<typeof Trigger>>;
  arrowClassName?: string;
}

/**
 * @deprecated Use `SelectTrigger` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectTrigger({
  className,
  children,
  variant,
  endAdornment,
  arrowClassName,
  ref,
  ...props
}: Props) {
  return (
    <Trigger
      data-test='select'
      ref={ref}
      className={cn(
        'flex h-10 w-full items-center justify-between rounded-lg border border-gray-200 px-3 py-2.5 text-sm focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
        variant === 'ghost' && 'border-none bg-transparent',
        className
      )}
      {...props}
    >
      {children}
      <div className='flex gap-2'>
        {endAdornment}
        <Icon asChild>
          <FontAwesomeIcon
            icon={faChevronDown}
            className={cn('size-5 opacity-50', arrowClassName)}
          />
        </Icon>
      </div>
    </Trigger>
  );
}

export default SelectTrigger;
